import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientActions, IThunkGetAvailableClientsByTeams } from '../types';

const onGetAvailableClientsByTeams: IThunkGetAvailableClientsByTeams = thunk(
  async ({ setAvailableClients }: Actions<IClientActions>, { clinicId, teamIds, params }) => {
    if (teamIds?.length) {
      const { data } = await api.client.getAvailableClientsByTeams(
        String(clinicId),
        teamIds,
        params,
      );
      setAvailableClients({ items: data.items, total: data.total });
    } else {
      setAvailableClients({ items: [], total: 0 });
    }
  },
);

export default onGetAvailableClientsByTeams;
